import React from 'react';
import { Box } from 'rebass';
import { useColorMode } from "theme-ui";
import posed from 'react-pose';
import { THEME_TRANSITION_DURATION } from "../border";
import theme from '../../gatsby-plugin-theme-ui';
import { useMediaQuery } from 'react-responsive';
import { isMobile } from 'react-device-detect';

const transition = {
	ease: 'linear',
	duration: THEME_TRANSITION_DURATION
};

const PosedDark = posed.div({
	default: {
		x: '100%',
		transition,
	},
	dark: {
		x: '0%',
		transition
	}
});

const PosedDefault = posed.div({
	default: {
		x: '0%',
		transition,
	},
	dark: {
		x: '-100%',
		transition
	}
});

const PosedMixed = posed(Box)({
	default: {
		x: '0%',
		transition,
	},
	dark: {
		x: '-50%',
		transition
	}
});

const BackgroundSlide = ({ defaultBg, darkBg, mixedBg, isQui }) => {
	const [colorMode] = useColorMode();
	const mixedMod = !!mixedBg;
	const isTabletOrMobile = useMediaQuery({ maxWidth: theme.breakpoints[1] }) || isMobile;

	return mixedMod ? (
		<PosedMixed pose={(isQui && !isTabletOrMobile) ? 'default' : colorMode} sx={{
			position: 'absolute',
			left: 0,
			top: 0,
			height: '100%',
			...(isQui ? { width: ['200%', '200%', '100%'] } : { width: '200%' }),
		}}>
			{mixedBg}
		</PosedMixed>
	) : (
		<Box sx={{
			position: 'absolute',
			left: 0,
			top: 0,
			height: '100%',
			width: '100%',
			overflow: 'hidden',
			'> div': {
				position: 'absolute',
				height: '100%',
				width: '100%',
				left: 0,
				top: 0,
			}
		}}>
			<PosedDefault pose={colorMode}>
				{defaultBg}
			</PosedDefault>
			<PosedDark pose={colorMode}>
				{darkBg}
			</PosedDark>
		</Box>
	);
};

export default BackgroundSlide;